export default __webpack_public_path__ + "static/media/the last ride.bea277d9.jpg";